exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login_input_div{margin-top:5%;padding:2px;border-radius:4px;border:1px solid #e52212}.login_input{font-size:17px}.logo_div{width:100%;margin-top:-100px;height:300px;background-color:#e52212;border-radius:60px}.logo_title{font-size:40px;font-weight:bolder;color:#fff;position:absolute;width:100%;text-align:center;margin-top:170px}", ""]);

// exports
